import { SVGProps } from "react";

const GroupOfPeopleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5358 10.9902H18.6797C18.8689 11.5082 18.9722 12.0672 18.9722 12.6499V19.665C18.9722 19.9079 18.93 20.1411 18.853 20.3579H21.9217C23.0679 20.3579 24.0005 19.4254 24.0005 18.2791V14.4549C24.0005 12.5445 22.4463 10.9902 20.5358 10.9902Z"
        fill="#69CFFD"
      />
      <path
        d="M5.02826 12.6499C5.02826 12.0672 5.13163 11.5082 5.32082 10.9902H3.46468C1.55425 10.9902 0 12.5445 0 14.4549V18.2792C0 19.4254 0.932524 20.358 2.07881 20.358H5.14747C5.07054 20.141 5.02826 19.9079 5.02826 19.665V12.6499Z"
        fill="#69CFFD"
      />
      <path
        d="M14.1241 9.18756H9.8807C7.97027 9.18756 6.41602 10.7418 6.41602 12.6522V19.6674C6.41602 20.05 6.72625 20.3603 7.10895 20.3603H16.8958C17.2785 20.3603 17.5888 20.0501 17.5888 19.6674V12.6522C17.5888 10.7418 16.0345 9.18756 14.1241 9.18756Z"
        fill="#69CFFD"
      />
      <path
        d="M12.0026 0C9.70511 0 7.83594 1.86917 7.83594 4.16676C7.83594 5.72518 8.69608 7.08626 9.96636 7.80085C10.5689 8.13977 11.2635 8.33347 12.0026 8.33347C12.7418 8.33347 13.4364 8.13977 14.0389 7.80085C15.3093 7.08626 16.1694 5.72514 16.1694 4.16676C16.1694 1.86922 14.3002 0 12.0026 0Z"
        fill="#69CFFD"
      />
      <path
        d="M4.68451 3.8866C2.96623 3.8866 1.56836 5.28447 1.56836 7.00275C1.56836 8.72102 2.96623 10.1189 4.68451 10.1189C5.12037 10.1189 5.53542 10.0286 5.91245 9.86632C6.56432 9.58567 7.10181 9.08887 7.43441 8.46657C7.66785 8.02982 7.80066 7.53156 7.80066 7.00275C7.80066 5.28452 6.40278 3.8866 4.68451 3.8866Z"
        fill="#69CFFD"
      />
      <path
        d="M19.3193 3.8866C17.601 3.8866 16.2031 5.28447 16.2031 7.00275C16.2031 7.53161 16.3359 8.02987 16.5694 8.46657C16.902 9.08891 17.4395 9.58572 18.0913 9.86632C18.4684 10.0286 18.8834 10.1189 19.3193 10.1189C21.0376 10.1189 22.4354 8.72102 22.4354 7.00275C22.4354 5.28447 21.0376 3.8866 19.3193 3.8866Z"
        fill="#69CFFD"
      />
    </svg>
  );
};

export default GroupOfPeopleIcon;
